
export const categories = [
  { id: "dairy", name: "Dairy" },
  { id: "vegetables", name: "Vegetables" },
  { id: "meat", name: "Meat" },
  { id: "snacks", name: "Snacks" },
  { id: "beverages", name: "Beverages" },
];


export const subCategories = [

  { id: "milk", name: "Milk", categoryId: "dairy" },
  { id: "cheese", name: "Cheese", categoryId: "dairy" },
  { id: "yogurt", name: "Yogurt", categoryId: "dairy" },


  { id: "leafy", name: "Leafy Greens", categoryId: "vegetables" },
  { id: "root", name: "Root Vegetables", categoryId: "vegetables" },
  { id: "fresh", name: "Fresh Vegetables", categoryId: "vegetables" },

  
  { id: "chicken", name: "Chicken", categoryId: "meat" },
  { id: "mutton", name: "Mutton", categoryId: "meat" },
  { id: "seafood", name: "Seafood", categoryId: "meat" },


  { id: "chips", name: "Chips", categoryId: "snacks" },
  { id: "biscuits", name: "Biscuits", categoryId: "snacks" },
  { id: "namkeen", name: "Namkeen", categoryId: "snacks" },


  { id: "softdrinks", name: "Soft Drinks", categoryId: "beverages" },
  { id: "juice", name: "Juice", categoryId: "beverages" },
  { id: "tea", name: "Tea / Coffee", categoryId: "beverages" },
];


export const mockItems = [
 
  {
    id: "1",
    name: "Amul Milk",
    categoryId: "dairy",
    subCategoryId: "milk",
    quantity: 2,
    price: 28,
    date: new Date().toISOString(),
    createdAt: Date.now(),
  },
  {
    id: "2",
    name: "Heritage Milk",
    categoryId: "dairy",
    subCategoryId: "milk",
    quantity: 1,
    price: 30,
    date: new Date().toISOString(),
    createdAt: Date.now() - 300000,
  },
  {
    id: "3",
    name: "Cheese Slice Pack",
    categoryId: "dairy",
    subCategoryId: "cheese",
    quantity: 1,
    price: 85,
    date: new Date().toISOString(),
    createdAt: Date.now() - 600000,
  },
  {
    id: "4",
    name: "Cheddar Cheese Block",
    categoryId: "dairy",
    subCategoryId: "cheese",
    quantity: 1,
    price: 120,
    date: new Date().toISOString(),
    createdAt: Date.now() - 900000,
  },
  {
    id: "5",
    name: "Plain Yogurt Cup",
    categoryId: "dairy",
    subCategoryId: "yogurt",
    quantity: 2,
    price: 25,
    date: new Date().toISOString(),
    createdAt: Date.now() - 1200000,
  },
  {
    id: "6",
    name: "Greek Yogurt",
    categoryId: "dairy",
    subCategoryId: "yogurt",
    quantity: 1,
    price: 45,
    date: new Date().toISOString(),
    createdAt: Date.now() - 1500000,
  },


  {
    id: "7",
    name: "Spinach",
    categoryId: "vegetables",
    subCategoryId: "leafy",
    quantity: 1,
    price: 30,
    date: new Date().toISOString(),
    createdAt: Date.now() - 1800000,
  },
  {
    id: "8",
    name: "Coriander Leaves",
    categoryId: "vegetables",
    subCategoryId: "leafy",
    quantity: 1,
    price: 15,
    date: new Date().toISOString(),
    createdAt: Date.now() - 2100000,
  },
  {
    id: "9",
    name: "Potato",
    categoryId: "vegetables",
    subCategoryId: "root",
    quantity: 2,
    price: 35,
    date: new Date().toISOString(),
    createdAt: Date.now() - 2400000,
  },
  {
    id: "10",
    name: "Onion",
    categoryId: "vegetables",
    subCategoryId: "root",
    quantity: 2,
    price: 32,
    date: new Date().toISOString(),
    createdAt: Date.now() - 2700000,
  },
  {
    id: "11",
    name: "Carrot",
    categoryId: "vegetables",
    subCategoryId: "root",
    quantity: 1,
    price: 40,
    date: new Date().toISOString(),
    createdAt: Date.now() - 3000000,
  },
  {
    id: "12",
    name: "Tomato",
    categoryId: "vegetables",
    subCategoryId: "fresh",
    quantity: 2,
    price: 28,
    date: new Date().toISOString(),
    createdAt: Date.now() - 3300000,
  },
  {
    id: "13",
    name: "Capsicum",
    categoryId: "vegetables",
    subCategoryId: "fresh",
    quantity: 1,
    price: 45,
    date: new Date().toISOString(),
    createdAt: Date.now() - 3600000,
  },
  {
    id: "14",
    name: "Cauliflower",
    categoryId: "vegetables",
    subCategoryId: "fresh",
    quantity: 1,
    price: 55,
    date: new Date().toISOString(),
    createdAt: Date.now() - 3900000,
  },


  {
    id: "15",
    name: "Chicken Breast",
    categoryId: "meat",
    subCategoryId: "chicken",
    quantity: 1,
    price: 240,
    date: new Date().toISOString(),
    createdAt: Date.now() - 4200000,
  },
  {
    id: "16",
    name: "Chicken Curry Cut",
    categoryId: "meat",
    subCategoryId: "chicken",
    quantity: 1,
    price: 220,
    date: new Date().toISOString(),
    createdAt: Date.now() - 4500000,
  },
  {
    id: "17",
    name: "Mutton Curry Cut",
    categoryId: "meat",
    subCategoryId: "mutton",
    quantity: 1,
    price: 480,
    date: new Date().toISOString(),
    createdAt: Date.now() - 4800000,
  },
  {
    id: "18",
    name: "Mutton Boneless",
    categoryId: "meat",
    subCategoryId: "mutton",
    quantity: 1,
    price: 520,
    date: new Date().toISOString(),
    createdAt: Date.now() - 5100000,
  },
  {
    id: "19",
    name: "Fish Fillet",
    categoryId: "meat",
    subCategoryId: "seafood",
    quantity: 1,
    price: 260,
    date: new Date().toISOString(),
    createdAt: Date.now() - 5400000,
  },
  {
    id: "20",
    name: "Prawns",
    categoryId: "meat",
    subCategoryId: "seafood",
    quantity: 1,
    price: 300,
    date: new Date().toISOString(),
    createdAt: Date.now() - 5700000,
  },


  {
    id: "21",
    name: "Lays Chips",
    categoryId: "snacks",
    subCategoryId: "chips",
    quantity: 2,
    price: 20,
    date: new Date().toISOString(),
    createdAt: Date.now() - 6000000,
  },
  {
    id: "22",
    name: "Kurkure",
    categoryId: "snacks",
    subCategoryId: "chips",
    quantity: 2,
    price: 20,
    date: new Date().toISOString(),
    createdAt: Date.now() - 6300000,
  },
  {
    id: "23",
    name: "Marie Biscuits",
    categoryId: "snacks",
    subCategoryId: "biscuits",
    quantity: 1,
    price: 35,
    date: new Date().toISOString(),
    createdAt: Date.now() - 6600000,
  },
  {
    id: "24",
    name: "Good Day Biscuits",
    categoryId: "snacks",
    subCategoryId: "biscuits",
    quantity: 1,
    price: 30,
    date: new Date().toISOString(),
    createdAt: Date.now() - 6900000,
  },
  {
    id: "25",
    name: "Aloo Bhujia",
    categoryId: "snacks",
    subCategoryId: "namkeen",
    quantity: 1,
    price: 55,
    date: new Date().toISOString(),
    createdAt: Date.now() - 7200000,
  },
  {
    id: "26",
    name: "Mixture",
    categoryId: "snacks",
    subCategoryId: "namkeen",
    quantity: 1,
    price: 50,
    date: new Date().toISOString(),
    createdAt: Date.now() - 7500000,
  },


  {
    id: "27",
    name: "Coca Cola",
    categoryId: "beverages",
    subCategoryId: "softdrinks",
    quantity: 2,
    price: 40,
    date: new Date().toISOString(),
    createdAt: Date.now() - 7800000,
  },
  {
    id: "28",
    name: "Pepsi",
    categoryId: "beverages",
    subCategoryId: "softdrinks",
    quantity: 2,
    price: 40,
    date: new Date().toISOString(),
    createdAt: Date.now() - 8100000,
  },
  {
    id: "29",
    name: "Orange Juice",
    categoryId: "beverages",
    subCategoryId: "juice",
    quantity: 1,
    price: 60,
    date: new Date().toISOString(),
    createdAt: Date.now() - 8400000,
  },
  {
    id: "30",
    name: "Apple Juice",
    categoryId: "beverages",
    subCategoryId: "juice",
    quantity: 1,
    price: 70,
    date: new Date().toISOString(),
    createdAt: Date.now() - 8700000,
  },
  {
    id: "31",
    name: "Tea Powder",
    categoryId: "beverages",
    subCategoryId: "tea",
    quantity: 1,
    price: 140,
    date: new Date().toISOString(),
    createdAt: Date.now() - 9000000,
  },
  {
    id: "32",
    name: "Instant Coffee",
    categoryId: "beverages",
    subCategoryId: "tea",
    quantity: 1,
    price: 180,
    date: new Date().toISOString(),
    createdAt: Date.now() - 9300000,
  },


  {
    id: "33",
    name: "Flavored Milk",
    categoryId: "dairy",
    subCategoryId: "milk",
    quantity: 1,
    price: 35,
    date: new Date().toISOString(),
    createdAt: Date.now() - 9600000,
  },
  {
    id: "34",
    name: "Fresh Cucumber",
    categoryId: "vegetables",
    subCategoryId: "fresh",
    quantity: 2,
    price: 30,
    date: new Date().toISOString(),
    createdAt: Date.now() - 9900000,
  },
  {
    id: "35",
    name: "Leafy Lettuce",
    categoryId: "vegetables",
    subCategoryId: "leafy",
    quantity: 1,
    price: 50,
    date: new Date().toISOString(),
    createdAt: Date.now() - 10200000,
  },
  {
    id: "36",
    name: "Chicken Sausage",
    categoryId: "meat",
    subCategoryId: "chicken",
    quantity: 1,
    price: 180,
    date: new Date().toISOString(),
    createdAt: Date.now() - 10500000,
  },
  {
    id: "37",
    name: "Fish Curry Cut",
    categoryId: "meat",
    subCategoryId: "seafood",
    quantity: 1,
    price: 240,
    date: new Date().toISOString(),
    createdAt: Date.now() - 10800000,
  },
  {
    id: "38",
    name: "Cream Biscuits",
    categoryId: "snacks",
    subCategoryId: "biscuits",
    quantity: 2,
    price: 40,
    date: new Date().toISOString(),
    createdAt: Date.now() - 11100000,
  },
  {
    id: "39",
    name: "Salted Chips",
    categoryId: "snacks",
    subCategoryId: "chips",
    quantity: 1,
    price: 25,
    date: new Date().toISOString(),
    createdAt: Date.now() - 11400000,
  },
  {
    id: "40",
    name: "Masala Namkeen",
    categoryId: "snacks",
    subCategoryId: "namkeen",
    quantity: 1,
    price: 60,
    date: new Date().toISOString(),
    createdAt: Date.now() - 11700000,
  },
  {
    id: "41",
    name: "Lemon Juice",
    categoryId: "beverages",
    subCategoryId: "juice",
    quantity: 1,
    price: 55,
    date: new Date().toISOString(),
    createdAt: Date.now() - 12000000,
  },
  {
    id: "42",
    name: "Cold Coffee",
    categoryId: "beverages",
    subCategoryId: "tea",
    quantity: 1,
    price: 90,
    date: new Date().toISOString(),
    createdAt: Date.now() - 12300000,
  },
  {
    id: "43",
    name: "Milkshake",
    categoryId: "beverages",
    subCategoryId: "juice",
    quantity: 1,
    price: 80,
    date: new Date().toISOString(),
    createdAt: Date.now() - 12600000,
  },
  {
    id: "44",
    name: "Fresh Paneer",
    categoryId: "dairy",
    subCategoryId: "cheese",
    quantity: 1,
    price: 95,
    date: new Date().toISOString(),
    createdAt: Date.now() - 12900000,
  },
  {
    id: "45",
    name: "Curd Bowl",
    categoryId: "dairy",
    subCategoryId: "yogurt",
    quantity: 1,
    price: 30,
    date: new Date().toISOString(),
    createdAt: Date.now() - 13200000,
  },
  {
    id: "46",
    name: "Mint Leaves",
    categoryId: "vegetables",
    subCategoryId: "leafy",
    quantity: 1,
    price: 20,
    date: new Date().toISOString(),
    createdAt: Date.now() - 13500000,
  },
  {
    id: "47",
    name: "Beetroot",
    categoryId: "vegetables",
    subCategoryId: "root",
    quantity: 1,
    price: 35,
    date: new Date().toISOString(),
    createdAt: Date.now() - 13800000,
  },
  {
    id: "48",
    name: "Ginger",
    categoryId: "vegetables",
    subCategoryId: "root",
    quantity: 1,
    price: 18,
    date: new Date().toISOString(),
    createdAt: Date.now() - 14100000,
  },
  {
    id: "49",
    name: "Green Tea",
    categoryId: "beverages",
    subCategoryId: "tea",
    quantity: 1,
    price: 160,
    date: new Date().toISOString(),
    createdAt: Date.now() - 14400000,
  },
  {
    id: "50",
    name: "Flavored Yogurt",
    categoryId: "dairy",
    subCategoryId: "yogurt",
    quantity: 1,
    price: 40,
    date: new Date(22/10/2010).toISOString(),
    createdAt: Date.now() - 1470000000,
  },
];